import React, { useEffect } from 'react';
import Hero from '../components/home/Hero/Hero';
import CourseCard from '../components/home/CourseCard/CourseCard';
import AboutAnnie from '../components/home/AboutAnnie/AboutAnnie';
import ContactSection from '../components/home/ContactSection/ContactSection';
import SectionHeader from '../components/common/SectionHeader/SectionHeader';
import { courses } from '../data/courses';
import styles from './HomePage.module.css';

/**
 * Home page — assembles Hero, Courses grid, About Annie, Contact form.
 */
function HomePage() {
  useEffect(() => {
    // Handle hash navigation on page load
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  return (
    <main>
      <Hero />

      {/* Courses */}
      <section className="section bg-cream" aria-label="Chương trình học">
        <div className="container">
          <SectionHeader
            label="Chương trình học"
            title="Hai lộ trình-một cam kết"
            desc="Dù bắt đầu với TOEIC hay JLPT, Annie's Class sẽ luôn đồng hành cùng bạn bằng lộ trình tinh gọn và tối ưu nhất."
            center
          />
          <div className={styles.coursesGrid}>
            {courses.map((course) => (
              <CourseCard key={course.id} course={course} />
            ))}
          </div>
        </div>
      </section>

      <AboutAnnie />
      <ContactSection />
    </main>
  );
}

export default HomePage;
